"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const input_checkbox_1 = require("../../components/input/input.checkbox");
const theme_1 = require("../../components/theme");
const tag_icon_style_1 = require("../tag.icon/tag.icon.style");
exports.CSS = {
    container: 'c-TagCardCheckbox',
    hasSelections: 'c-TagCardCheckbox__has-selections',
    badge: 'c-TagCardCheckbox_badge',
};
exports.Style = {
    [exports.CSS.container]: {
        display: 'flex',
        alignItems: 'center',
    },
    [`${exports.CSS.container} .${input_checkbox_1.CSS.container}`]: {
        display: 'none',
        width: 'inherit',
        height: 'inherit',
    },
    [`${exports.CSS.container}:hover .${tag_icon_style_1.CSS.container}`]: {
        display: 'none',
    },
    [`${exports.CSS.container}:hover .${input_checkbox_1.CSS.container}`]: {
        display: 'flex',
    },
    [`${exports.CSS.container}.${exports.CSS.hasSelections} .${input_checkbox_1.CSS.container}`]: {
        display: 'flex',
    },
    [`${exports.CSS.container} .${exports.CSS.badge}`]: {
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'left',
        fontFamily: theme_1.DefaultTheme.font.familyCondensed,
        fontWeight: theme_1.DefaultTheme.font.weight.bold,
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2,
        textShadow: theme_1.DefaultTheme.shadow.text,
        position: 'absolute',
        cursor: 'pointer',
        color: theme_1.DefaultTheme.font.color.white,
        border: `2px solid ${theme_1.DefaultTheme.font.color.white}`,
    },
};
//# sourceMappingURL=tag.card.checkbox.style.js.map